import dayjs, { locale, isDayjs } from 'dayjs'

import { useLocale } from '~/composables/useLocale'
import 'dayjs/locale/ja'
import 'dayjs/locale/th'
import 'dayjs/locale/vi'

const { currentLocale } = useLocale()
// TODO: フォーマット日付はリアクティブにはなっていないので、リロードしないと反映されない
locale(currentLocale.value)

type DateLike = dayjs.Dayjs | Date | string

export type Dayjs = dayjs.Dayjs

export const currentBusinessDate = () => {
  // 夜勤を考慮して午前4時を1日の始まりとする
  const businessHourOffset = 4 // TODO: 拠点から取得するに変更予定
  return currentDate().subtract(businessHourOffset, 'hour')
}

export function currentDate(): dayjs.Dayjs {
  return dayjs()
}

export function nextDate(): dayjs.Dayjs {
  return dayjs().add(1, 'day')
}

export function parseDate(dateLike: DateLike | null | undefined): dayjs.Dayjs {
  return dayjs(dateLike)
}

export const getYYYYMMList = (start: DateLike, end: DateLike): string[] => {
  const startDay = parseDate(start)
  const endDay = parseDate(end)
  const diff = endDay.diff(startDay, 'month')
  const list = Array.from({ length: diff + 1 }, (_, i) => {
    const day = startDay.add(i, 'month')
    return formatYYYYMM(day)
  })
  return list
}

export const formatYYYY = (date: Dayjs): string => {
  return date.format('YYYY')
}

export const formatMM = (date: Dayjs): string => {
  return date.format('MM')
}

export const formatYYYYMM = (date: Dayjs): string => {
  return date.format('YYYY-MM')
}

export const formatDate = (date: Dayjs): string => {
  return date.format('YYYY-MM-DD')
}

export const formatDateTime = (date: Dayjs): string => {
  return date.format('YYYY-MM-DD HH:mm:ss')
}

export const isDate = (date: unknown): date is Date | Dayjs => {
  return date instanceof Date || isDayjs(date)
}
